import { FETCH_ALL_PROVINCES_REQUEST, FETCH_ALL_PROVINCES_SUCCESS, FETCH_ALL_PROVINCES_ERROR } from '../constants/ActionTypes';

export default function fetchAllProvincesError(state = false, action) {
    switch (action.type) {
        case FETCH_ALL_PROVINCES_REQUEST:
        case FETCH_ALL_PROVINCES_SUCCESS:
            return false;
        case FETCH_ALL_PROVINCES_ERROR:
            return true;
        default:
            return state;
    }
}
